/**
 * Wordmark — five-point star mark + "Brightstars" text.
 * Tone toggles dark/light.
 */
export function Logo({
  collapsed,
  className = '',
  tone = 'fg',
}: {
  collapsed?: boolean
  className?: string
  tone?: 'fg' | 'inverted'
}) {
  const fill = tone === 'inverted' ? 'fill-white' : 'fill-[var(--color-primary)]'
  const text = tone === 'inverted' ? 'text-white' : 'text-fg'
  return (
    <span className={`inline-flex items-center gap-2 ${className}`}>
      <svg
        viewBox="0 0 24 24"
        className={`h-5 w-5 ${fill}`}
        aria-hidden="true"
      >
        <path d="M12 2.5 L14.94 8.46 L21.5 9.42 L16.75 14.05 L17.88 20.58 L12 17.5 L6.12 20.58 L7.25 14.05 L2.5 9.42 L9.06 8.46 Z" />
      </svg>
      {!collapsed && (
        <span className={`text-base font-semibold tracking-tight ${text}`}>
          Brightstars
        </span>
      )}
    </span>
  )
}
